import { createType } from 'framework/utils/createType';

export const TroubleshootTabTypes = createType('general', 'failed-events', 'es-subscriptions', 'tokens', 'notifications', 'noah-user-setups');
export type TroubleshootTabType = typeof TroubleshootTabTypes[number];
